import { ThemeIcon } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import { type FC } from 'react'

// Shown only when a record is affirmatively known to be absent — see isPaymentSetupEmpty.
export const PaymentSetupTabAlert: FC = () => (
  <ThemeIcon
    color='orange'
    radius='xl'
    size='sm'
    variant='light'
  >
    <IconAlertCircle size={14} />
  </ThemeIcon>
)
